import { render, staticRenderFns } from "./BloodPressure.vue?vue&type=template&id=777828ce"
import script from "./BloodPressure.vue?vue&type=script&lang=js"
export * from "./BloodPressure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports